export default __webpack_public_path__ + "static/media/flag-en.80da69bd.svg";